/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/formatMoney.js":
/*!*******************************!*\
  !*** ./src/js/formatMoney.js ***!
  \*******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   formatMoney: () => (/* binding */ formatMoney)
/* harmony export */ });
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------

function formatMoney(cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || "${{amount}}";
  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? decimal + parts[1] : '';
    return dollars + cents;
  }
  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
  }
  return formatString.replace(placeholderRegex, value);
}
;

/***/ }),

/***/ "./node_modules/smooth-zoom/dist/zoom.esm.js":
/*!***************************************************!*\
  !*** ./node_modules/smooth-zoom/dist/zoom.esm.js ***!
  \***************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Zoom)
/* harmony export */ });
/*
 *
 *  Source of the code below
 *  https://stackoverflow.com/a/2541680
 *
 */
function getAverageRGB(img, width, height) {
    const blockSize = 20;
    const rgb = { r: 0, g: 0, b: 0 };
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const optimizedWidth = Math.sqrt(width);
    const optimizedHeight = Math.sqrt(height);
    if (!ctx) {
        return rgb;
    }
    canvas.width = optimizedWidth;
    canvas.height = optimizedHeight;
    try {
        ctx.drawImage(img, 0, 0, optimizedWidth, optimizedHeight);
        const imageData = ctx.getImageData(0, 0, optimizedWidth, optimizedHeight);
        const { data } = imageData;
        const { length } = data;
        const count = length / blockSize;
        for (let i = 0; i < length; i += blockSize) {
            rgb.r += data[i];
            rgb.g += data[i + 1];
            rgb.b += data[i + 2];
        }
        rgb.r = Math.floor(rgb.r / count);
        rgb.g = Math.floor(rgb.g / count);
        rgb.b = Math.floor(rgb.b / count);
    }
    catch (_a) {
        return rgb;
    }
    return rgb;
}

function Zoom(target, { background, useMaximumSize = true, onTransitionEnd, onClick, } = {}) {
    const zoom = (image) => {
        const src = image.currentSrc || image.src;
        const { srcset, naturalWidth } = image;
        const { offsetWidth: screenWidth, clientHeight: screenHeight } = document.documentElement;
        const { width, height, left, top } = image.getBoundingClientRect();
        const wrapX = screenWidth / 2 - left - width / 2;
        const wrapY = -top + (screenHeight - height) / 2;
        const maxScale = Math.min(screenWidth / width, screenHeight / height);
        const sizes = srcset.match(/ ([0-9]+)w/gm) || [];
        const maxWidth = useMaximumSize
            ? Math.max(naturalWidth, ...sizes
                .map((x) => +x.trim().replace("w", ""))
                .filter((x) => !Number.isNaN(x) && naturalWidth < x))
            : naturalWidth;
        const imageScale = maxWidth / width;
        const scale = Math.min(maxScale, imageScale);
        const bg = document.createElement("div");
        const imageClone = document.createElement("img");
        const removeImage = () => {
            bg.classList.remove("zoom-bg--reveal");
            imageClone.style.transform = "";
            imageClone.addEventListener("transitionend", () => {
                bg.remove();
                image.classList.remove("zoom-original--hidden");
                imageClone.remove();
            }, { once: true });
            bg.removeEventListener("click", removeImage);
            imageClone.removeEventListener("click", removeImage);
            window.removeEventListener("scroll", removeImage);
            window.removeEventListener("resize", removeImage);
        };
        bg.classList.add("zoom-bg");
        if (background) {
            if (background === "auto") {
                const { r, g, b } = getAverageRGB(image, width, height);
                bg.style.backgroundColor = `rgba(${r}, ${g}, ${b}, 0.95)`;
            }
            else {
                bg.style.background = background;
            }
        }
        imageClone.classList.add("zoom-img");
        imageClone.src = src;
        imageClone.width = width;
        imageClone.height = height;
        imageClone.style.top = `${top + window.scrollY}px`;
        imageClone.style.left = `${left}px`;
        imageClone.style.width = `${width}px`;
        imageClone.style.height = `${height}px`;
        bg.addEventListener("click", removeImage, { once: true });
        imageClone.addEventListener("click", removeImage, { once: true });
        imageClone.addEventListener("transitionend", () => {
            onTransitionEnd === null || onTransitionEnd === void 0 ? void 0 : onTransitionEnd(imageClone);
        }, { once: true });
        window.addEventListener("scroll", removeImage, {
            once: true,
            passive: true,
        });
        window.addEventListener("resize", removeImage, {
            once: true,
            passive: true,
        });
        document.body.append(bg, imageClone);
        // Hide original image
        image.classList.add("zoom-original--hidden");
        // For transition
        window.requestAnimationFrame(() => {
            window.setTimeout(() => {
                imageClone.style.transform = `matrix(${scale}, 0, 0, ${scale}, ${wrapX}, ${wrapY})`;
                bg.classList.add("zoom-bg--reveal");
            });
        });
    };
    const handleClick = (event) => {
        onClick === null || onClick === void 0 ? void 0 : onClick(event.target);
        zoom(event.target);
    };
    const addZoomEvent = (element) => {
        var _a;
        if (!(element instanceof HTMLElement)) {
            return;
        }
        if (element.tagName === "IMG") {
            element.addEventListener("click", handleClick);
            return;
        }
        (_a = element.querySelector("img")) === null || _a === void 0 ? void 0 : _a.addEventListener("click", handleClick);
    };
    const removeZoomEvent = (element) => {
        var _a;
        if (!(element instanceof HTMLElement)) {
            return;
        }
        if (element.tagName === "IMG") {
            element.removeEventListener("click", handleClick);
            return;
        }
        (_a = element.querySelector("img")) === null || _a === void 0 ? void 0 : _a.removeEventListener("click", handleClick);
    };
    const attach = (target) => {
        if (!target) {
            return;
        }
        if (typeof target === "string") {
            document.querySelectorAll(target).forEach(addZoomEvent);
            // Add cursor style for target
            const style = document.createElement("style");
            const { head } = document;
            style.appendChild(document.createTextNode(`${target}{cursor:zoom-in}`));
            head.appendChild(style);
            return;
        }
        if (target instanceof HTMLElement) {
            addZoomEvent(target);
            return;
        }
        target.forEach(addZoomEvent);
    };
    const detach = (target) => {
        if (!target) {
            return;
        }
        if (typeof target === "string") {
            document.querySelectorAll(target).forEach(removeZoomEvent);
            return;
        }
        if (target instanceof HTMLElement) {
            removeZoomEvent(target);
            return;
        }
        target.forEach(removeZoomEvent);
    };
    if (target) {
        attach(target);
    }
    return {
        zoom,
        attach,
        detach,
    };
}

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') {
    return;
  }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".zoom-bg,.zoom-img{cursor:zoom-out;z-index:90000}.zoom-img{display:block;position:absolute;transition:transform .3s ease-in-out}.zoom-bg{background-color:rgba(0,0,0,.95);height:100vh;left:0;opacity:0;position:fixed;top:0;transition:opacity .3s ease-in-out;width:100vw}.zoom-bg.zoom-bg--reveal{opacity:1}.zoom-original--hidden{visibility:hidden}";
styleInject(css_248z);




/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
(() => {
/*!***************************!*\
  !*** ./src/js/product.js ***!
  \***************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var smooth_zoom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! smooth-zoom */ "./node_modules/smooth-zoom/dist/zoom.esm.js");
/* harmony import */ var _formatMoney__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./formatMoney */ "./src/js/formatMoney.js");



/*
 BG: Init smooth-zoom, just apply the class below a zoomable image
https://github.com/marshall-ku/smooth-zoom
 */
(0,smooth_zoom__WEBPACK_IMPORTED_MODULE_0__["default"])(".zoomable");

/**
 * BG: This is a BIG function, that has alot of smaller functions. The whole purpose of this is to determine the variant options the user has selected, while highlighting the available and unavailable variants after each choice they make, and updating the price, and variant id field. This function works best when we have the first available variants selected.
 */
var productVariants = function productVariants() {
  var productVariants = document.querySelector('#product-variants');
  var radioBtns = productVariants.querySelectorAll('input[type="radio"]');
  var variantFieldsets = productVariants.querySelectorAll('fieldset');
  var masterVariantField = document.querySelector('form[action*="/cart/add"] input[name="id"]');
  var cartBtn = document.querySelector('form[action*="/cart/add"] button[type="submit"]');
  var preOrderInfo = document.querySelector('.js-pre-order-info');

  //get the variantData from the json markup.
  var getVariantData = function getVariantData() {
    return JSON.parse(productVariants.querySelector('[type="application/json"]').textContent);
  };

  //Debug
  //console.log(JSON.parse(productVariants.querySelector('[type="application/json"]').textContent));

  //BG: When the user makes a selection, update the field legend to include that choice.
  /**
   * 
   * @param {*} radio | Node - Passed when the user selects a radio on variant selector.
   */
  var fieldsetLegend = function fieldsetLegend(radio) {
    var parentLegend = radio.closest('fieldset');
    var legendLabel = parentLegend.querySelector('legend').getAttribute('data-fieldset-label');
    parentLegend.querySelector('legend span').innerHTML = legendLabel + ': ' + '<span class="uppercase font-bold">' + radio.value + '</span>';
    // Output the value of the currently selected radio button as an object
  };

  //BG: Triggered by the finalVariant function, we determine if the final variant Id selected is available or not, and update the button to reflect that choice.

  var addToBagBtn = function addToBagBtn(available, variantId) {
    // Pre order check
    var preOrder = false;
    var preOrderCheck = document.querySelector('input[data-variant-id="' + variantId + '"]');
    if (typeof preOrderCheck != 'undefined' && preOrderCheck != null) {
      if (preOrderCheck.classList.contains('js-pre-order')) {
        preOrder = true;
      }
    }
    var preOrderDate = document.querySelector('[data-pre-order-date="' + variantId + '"]');
    if (typeof preOrderDate != 'undefined' && preOrderDate != null) {
      var preOrderDateText = preOrderDate.innerHTML;
    }
    if (preOrder == true) {
      cartBtn.classList.remove('btn-disabled');
      cartBtn.classList.add('btn-primary');
      cartBtn.classList.add('pre-order');
      cartBtn.innerHTML = window.product.preOrder;
      cartBtn.disabled = false;
      preOrderInfo.innerHTML = window.product.preOrderDateIntro + " " + preOrderDateText;
      preOrderInfo.classList.remove('hidden');
    } else if (available) {
      cartBtn.classList.remove('btn-disabled');
      cartBtn.classList.add('btn-primary');
      cartBtn.classList.remove('pre-order');
      cartBtn.classList.remove('pre-order');
      cartBtn.innerHTML = window.product.addToCart;
      cartBtn.disabled = false;
      preOrderInfo.classList.add('hidden');
    } else {
      cartBtn.classList.add('btn-disabled');
      cartBtn.classList.remove('btn-primary');
      cartBtn.innerHTML = window.product.soldOut;
      cartBtn.disabled = true;
      preOrderInfo.classList.add('hidden');
    }

    // Update Swatch URL to include currently selected variant
    var productSwatch = document.querySelector('.js-product-swatch');
    var currentSelectedVariant = document.querySelector('.variant-radio input[type="radio"]:checked');
    console.log(currentSelectedVariant);
    var currentSelectedValue = currentSelectedVariant.value;
    console.log(currentSelectedValue);

    // Grab the swatch links

    var swatchLinks = document.querySelectorAll('.js-swatch-link');
    var matchingSwatchVariantId = null;

    // Loop through each swatch link, match the variant title to the currently selected variant titile, then update the url with the variant id.

    swatchLinks.forEach(function (swatchLink) {
      var swatchProductVariants = swatchLink.getAttribute('data-swatch-product-variants');
      var swatchVariantValues = swatchProductVariants.split(' ').map(function (value) {
        return value.split('-')[0];
      });
      var swatchVariantId = swatchProductVariants.split(' ').map(function (value) {
        return value.split('-')[1];
      });
      if (swatchVariantValues.includes(currentSelectedValue)) {
        matchingSwatchVariantId = swatchVariantId[swatchVariantValues.indexOf(currentSelectedValue)];
        swatchLink.setAttribute('href', swatchLink.getAttribute('href').replace(/\?variant=.*$/, '') + '?variant=' + matchingSwatchVariantId);
      }
    });
  };

  //BG: the finalVariant funciton below will trigger this function, we essentially need the variant ID to query the price
  var variantPrice = function variantPrice(variantId) {
    var productPrice = document.querySelector('.js-product-price');
    var productCAP = document.querySelector('.js-product-compare-at-price');
    var variantData = getVariantData().filter(function (variant) {
      return variant.id === variantId;
    });

    //Update the product price, with the selected variant, and format the money.
    productPrice.innerHTML = (0,_formatMoney__WEBPACK_IMPORTED_MODULE_1__.formatMoney)(variantData[0].price, window.theme.moneyFormat);

    //Is there a Compare at price (CAP)? if so, let's update that too. 
    if (variantData[0].compare_at_price != null) {
      //if CAP does exist, remove the hidden class if present.
      productCAP.classList.remove('hidden');
      //Update the CAP, with the selected variant, and format the money.
      productCAP.innerHTML = (0,_formatMoney__WEBPACK_IMPORTED_MODULE_1__.formatMoney)(variantData[0].compare_at_price, window.theme.moneyFormat);
    } else {
      //No CAP?, No Problem, let's just hide it.
      productCAP.classList.add('hidden');
    }
  };

  /**
   * BG: Once the user has selected all variant options, this function then triggers to update the variant ID field, price and url based on the users choice. 
   */
  var finalVariant = function finalVariant(variant) {
    //BG: let's update the id input to the selected variant id
    masterVariantField.value = variant.id;
    //BG: Trigger the price update based on the variant ID
    variantPrice(variant.id);
    //BG: Update the add to bag btn based on the variant being available or not.
    addToBagBtn(variant.available, variant.id);

    //Update the url with the user's variant choice.
    //Get the current URL without parameters
    var currentURLWithoutParams = window.location.href.split('?')[0];
    //update the page url with paramters
    history.pushState(null, null, currentURLWithoutParams + '?variant=' + variant.id);
  };

  /**
   * BG: There's a lot going on here, basically we determine how many variant options there are, and based on how many options there are, will determine the logic and approach. Essentially, we're determining what options are available or not available based on the user's choice. 
   * checkedBtns(Array) - Checked radio buttons.
   */
  var remainingOptions = function remainingOptions(checkedBtns) {
    //If only one variant, remove all unavailable classes.
    if (variantFieldsets.length === 1) {
      productVariants.querySelectorAll('.js-unavailable-variant').forEach(function (label) {
        label.classList.remove('js-unavailable-variant');
      });
    }

    // for each checked radio button.
    checkedBtns.forEach(function (radio, index) {
      //First fieldset option
      if (index === 0) {
        //console.log('fire option 1');
        var remainingVariants;
        //if only one variant, then find all the unavailable variants
        if (variantFieldsets.length === 1) {
          remainingVariants = getVariantData().filter(function (variant) {
            return variant.available === false;
          });
        } else if (variantFieldsets.length === 2) {
          //if two variants, then find all the variants from option1 that match the selected radio option, and sort by unavailable first.
          remainingVariants = getVariantData().filter(function (variant) {
            return variant.option1 === checkedBtns[0].value;
          }).sort(function (variant) {
            return variant.available ? 1 : -1;
          });
        } else if (variantFieldsets.length > 2) {
          //if three variants, find all the variants from option1 and option2 that match the selected values for 1 & 2, and sort by unavailable first.
          remainingVariants = getVariantData().filter(function (variant) {
            return variant.option1 === checkedBtns[0].value && variant.option2 === checkedBtns[1].value;
          }).sort(function (variant) {
            return variant.available ? 1 : -1;
          });
        }
        //console.log(index);
        //console.log({remainingVariants});
        remainingVariants.forEach(function (variant) {
          //if one variant, highlight the unavailable options.
          if (variantFieldsets.length === 1) {
            productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option1, "\"]")).classList.add('js-unavailable-variant');
          }

          //if there is two variants, highlight the unavailable variants, and remove the class if the variant is available. During this array, we may come across the same item twice, therefore we sort by unavailable first to always ensure the available option is always highlighted at the end.
          if (variantFieldsets.length >= 2) {
            if (variant.available) {
              productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option2, "\"]")).classList.remove('js-unavailable-variant');
            } else {
              productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option2, "\"]")).classList.add('js-unavailable-variant');
            }
          }

          //if there is three variants, same as above.
          if (variantFieldsets.length > 2) {
            if (variant.available) {
              productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option3, "\"]")).classList.remove('js-unavailable-variant');
            } else {
              productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option3, "\"]")).classList.add('js-unavailable-variant');
            }
          }
        });
      }
      //Second Radio Option
      if (index === 1) {
        //console.log('fire option 2');
        var _remainingVariants;
        if (variantFieldsets.length === 2) {
          //if two variants, then find all the variants from option2 that match the selected radio option, and sort by unavailable first.
          _remainingVariants = getVariantData().filter(function (variant) {
            return variant.option2 === checkedBtns[1].value;
          }).sort(function (variant) {
            return variant.available ? 1 : -1;
          });
        } else if (variantFieldsets.length > 2) {
          //if three variants, find all the variants from option2 and option3 that match the selected values for 2 & 3, and sort by unavailable first.
          _remainingVariants = getVariantData().filter(function (variant) {
            return variant.option2 === checkedBtns[1].value && variant.option3 === checkedBtns[2].value;
          }).sort(function (variant) {
            return variant.available ? 1 : -1;
          });
        }
        //console.log(index);
        //console.log({remainingVariants});
        _remainingVariants.forEach(function (variant) {
          //if there is two variants, highlight the unavailable variants, and remove the class if the variant is available. During this array, we may come across the same item twice, therefore we sort by unavailable first to always ensure the available option is always highlighted at the end.
          if (variantFieldsets.length >= 2) {
            if (variant.available) {
              productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option1, "\"]")).classList.remove('js-unavailable-variant');
            } else {
              productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option1, "\"]")).classList.add('js-unavailable-variant');
            }
          }

          //if there is three variants, same as above.
          if (variantFieldsets.length > 2) {
            if (variant.available) {
              productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option3, "\"]")).classList.remove('js-unavailable-variant');
            } else {
              productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option3, "\"]")).classList.add('js-unavailable-variant');
            }
          }
        });
      }

      //Third Radio Option
      if (index === 2) {
        //console.log('fire option 3');
        //find all the variants from option3 and option1 that match the selected values for 3 & 1, and sort by unavailable first.
        var _remainingVariants2 = getVariantData().filter(function (variant) {
          return variant.option3 === checkedBtns[2].value && variant.option1 === checkedBtns[0].value;
        }).sort(function (variant) {
          return variant.available ? 1 : -1;
        });
        //console.log(index);
        //console.log({remainingVariants});
        _remainingVariants2.forEach(function (variant) {
          if (variant.available) {
            productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option1, "\"]")).classList.remove('js-unavailable-variant');
          } else {
            productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option1, "\"]")).classList.add('js-unavailable-variant');
          }
          if (variant.available) {
            productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option2, "\"]")).classList.remove('js-unavailable-variant');
          } else {
            productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option2, "\"]")).classList.add('js-unavailable-variant');
          }
        });
      }
    });
  };

  //BG: For each radio button, attach an event listener that triggers when it's checked/unchecked.  
  radioBtns.forEach(function (radio) {
    return radio.addEventListener('change', function () {
      //After a selection has been made, gather all checked options.
      var radioBtnsChecked = productVariants.querySelectorAll('input[type="radio"]:checked');

      //By default, we assume there will always be one radio button checked.
      var optionCombine = radioBtnsChecked[0].value;
      //console.log(radioBtnsChecked[0].value);

      //if there are two variant fields, we assume there will be two checked radio btns so add this to the variable.
      if (variantFieldsets.length >= 2) {
        //console.log(radioBtnsChecked[1].value);
        optionCombine += ' / ' + radioBtnsChecked[1].value;
      }
      //if there are three variant fields, we assume there will be three checked radio btns so add this to the variable.
      if (variantFieldsets.length > 2) {
        //console.log(radioBtnsChecked[2].value);
        optionCombine += ' / ' + radioBtnsChecked[2].value;
      }
      //console.log({optionCombine});
      //BG: with the combined result we search for the variant based on the variant.title.
      var combineVariant = getVariantData().filter(function (variant) {
        return variant.title === optionCombine;
      });
      //console.log({combineVariant});
      finalVariant(combineVariant[0]);
      // fieldsetLegend(radio);
      remainingOptions(radioBtnsChecked);
    });
  });
  var currentRadioBtnsChecked = productVariants.querySelectorAll('input[type="radio"]:checked');
  remainingOptions(currentRadioBtnsChecked);
};
var variantSingle = document.querySelector('.single-variant');
if (!variantSingle) {
  productVariants();
}

/*
BG: Uses localStorage to store the products the user visits, and displays it back to the customer in a recently viewed section.
*/
var recentlyViewedProducts = function recentlyViewedProducts() {
  var recentlyViewed = document.querySelector('.js-recently-viewed-products');
  var maxProducts = 6;
  var savedRecentProducts = JSON.parse(localStorage.getItem("recentProducts"));
  //by default, we assume the prodict array is empty. 
  var productArray = [];
  var flickityPresent = false;

  //We planning on using flickity?, we check to see if the inline attribute is present.
  if (recentlyViewed.hasAttribute('data-flickity')) {
    flickityPresent = true;
  }

  //if localstorage exists, retrieve the list and output it
  if (savedRecentProducts) {
    //BG: if array is greater than the maxProducts, then delete the first item in the array
    if (savedRecentProducts.length > maxProducts) {
      savedRecentProducts.shift();
    }
    //update the product array to be the array stored in localStorage.
    productArray = savedRecentProducts;
    if (productArray.length >= 3) {
      recentlyViewed.parentNode.classList.remove('hidden');
    }
    productArray.forEach(function (productHandle, index) {
      //console.log(window.Shopify.routes.root + `products/${productHandle}?view=card`);
      //using that productHandle, get the product markup.
      fetch(window.Shopify.routes.root + "products/".concat(productHandle, "?view=card")).then(function (response) {
        return response.text();
      }).then(function (html) {
        //BG: we get the first 26 characters of the response, to check if we're returning what we expect (the card product template) if the product no longer exists, it will 404, so we will return markup we don't intend, therefore we check to see if the preview does include what we expect, if it does, we show it, if it doesn't we remove it from the array.
        var preview = html.slice(0, 26);
        if (preview.includes("product-card")) {
          var flickitySlider = recentlyViewed.querySelector('.flickity-slider');
          if (!!flickitySlider) {
            flickitySlider.innerHTML += html;
          } else {
            recentlyViewed.innerHTML += html;
          }

          //if last product, and we're using flickity....
          if (index === productArray.length - 1 && flickityPresent && flickitySlider) {
            //after a breif delay, re-init flickity.
            setTimeout(function () {
              var flkty = Flickity.data('.js-recently-viewed-products');
              flkty.reloadCells();
              flkty.resize();
            }, 1000);
          }
          if (index === products.length - 1) {
            //after a breif delay, re-init Yotpo.
            setTimeout(function () {
              yotpoCallback();
            }, 1000);
          }
        } else {
          //if the preview doesn't include the product card, we're not returning what we expect, remove it from the array.
          var removeProd = productArray.indexOf(productHandle);
          if (removeProd > -1) {
            productArray.splice(removeProd, 1);
          }

          //BG: Update localStorage, so we don't try and show it again.
          localStorage.setItem("recentProducts", JSON.stringify(productArray));
        }
      })["catch"](function (error) {
        console.error('Error:', error);
      });
    });
  }
  // if the recently viewed section has the product handle, add this product to the array.
  if (recentlyViewed.hasAttribute('data-product-handle')) {
    var productHandle = recentlyViewed.getAttribute('data-product-handle');

    //BG: only add the product to the array, if it doesn't already exist
    if (productArray.indexOf(productHandle) == -1) {
      productArray.push(productHandle);
    }
    //BG: Update localStorage
    localStorage.setItem("recentProducts", JSON.stringify(productArray));
  }
};

//check if the section exists, if so, run the function.
if (!!document.querySelector('.js-recently-viewed-products')) {
  recentlyViewedProducts();
}

/*
BG: This function uses the recommended products API by Shopify. We firstly pass over the product ID we want to display recommended on, and then for each result, request the product.card template to get the look.
*/
var recommendedProducts = function recommendedProducts() {
  //determine if the recommendProducts class section is present
  var recommended = document.querySelector('.js-recommended-products');
  var flickityPresent = false;

  //We planning on using flickity?, we check to see if the inline attribute is present.
  if (recommended.hasAttribute('data-flickity')) {
    flickityPresent = true;
  }
  //if it is....
  if (!!recommended) {
    //Get the productID from the data attribute
    var productID = parseInt(recommended.getAttribute('data-product-id'));

    //using that productID, query the recommended products API
    fetch(window.Shopify.routes.root + "recommendations/products.json?product_id=".concat(productID, "&limit=8")).then(function (response) {
      return response.json();
    }).then(function (_ref) {
      var products = _ref.products;
      //with the response, loop through each product.
      products.forEach(function (product, index) {
        //console.log(product.handle)
        //we run a second fetch to get the product card HTML markup
        fetch(window.Shopify.routes.root + "products/".concat(product.handle, "?view=card")).then(function (response) {
          return response.text();
        }).then(function (html) {
          var flickitySlider = recommended.querySelector('.flickity-slider');

          //if flickity isn't present, it might be that it's not being used at a particular size, so we drop it in the section anyways.
          if (flickitySlider) {
            flickitySlider.innerHTML += html;
          } else {
            recommended.innerHTML += html;
          }

          //if last product, and we're using flickity....
          if (index === products.length - 1 && flickityPresent && flickitySlider) {
            //after a breif delay, re-init flickity.
            setTimeout(function () {
              var flkty = Flickity.data('.js-recommended-products');
              flkty.reloadCells();
              flkty.resize();
            }, 1000);
          }
          if (index === products.length - 1) {
            //after a breif delay, re-init Yotpo.
            setTimeout(function () {
              yotpoCallback();
            }, 1000);
          }
        });
      });
    })["catch"](function (error) {
      console.error('Error:', error);
    });
  }
};
recommendedProducts();
})();

/******/ })()
;